import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { addCartoVectorLayer } from '@/constants/cartoBasemap';

export function CartoVectorBasemap() {
  const map = useMap();

  useEffect(() => {
    const layer = addCartoVectorLayer(map);
    return () => {
      map.removeLayer(layer);
    };
  }, [map]);

  return null;
}
